import { useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import apiClient from '../../services/api';

function BookingActionHandler() {
  const { id, action } = useParams();
  const [status, setStatus] = useState('pending');

  useEffect(() => {
    const processBooking = async () => {
      try {
        // Map common actions to backend expected endpoints if necessary
        // In AdminController: /admin/bookings/:id/confirm, /admin/bookings/:id/reject, /admin/bookings/:id/deliver
        // The action parameter should probably match these or be mapped.

        let apiAction = action;
        if (action === 'cancel') apiAction = 'reject';

        const res = await apiClient.post(`/admin/bookings/${id}/${apiAction}`);

        if (res.status === 200 || res.status === 201) {
          setStatus('success');
        } else {
          setStatus('error');
        }
      } catch (error) {
        console.error('Booking action error:', error);
        setStatus('error');
      }
    };

    processBooking();
  }, [id, action]);

  return (
    <div className="flex flex-col items-center justify-center mt-16 p-4">
      <div className="bg-white p-8 rounded-lg shadow-md max-w-md w-full text-center">
        {status === 'pending' && (
          <div className="flex flex-col items-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-500 mb-4"></div>
            <p className="text-gray-600">Processing your request...</p>
          </div>
        )}
        {status === 'success' && (
          <div className="text-green-600">
            <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7"></path>
            </svg>
            <p className="text-xl font-semibold">
              {action === 'confirm'
                ? 'Booking confirmed successfully!'
                : action === 'cancel' || action === 'reject'
                  ? 'Booking rejected successfully.'
                  : 'Action completed.'}
            </p>
          </div>
        )}
        {status === 'error' && (
          <div className="text-red-600">
            <svg className="w-16 h-16 mx-auto mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
            <p className="text-xl font-semibold">Failed to process request.</p>
            <p className="text-gray-500 mt-2">Please try again later or contact support.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BookingActionHandler;
